export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7959.51c40d15.jpg";